import { Type } from 'theme/types';
import styled from "styled-components";
import { Text } from "theme/theme";

export const TextOtp = styled(Text)`
  ${({theme}: Type) => theme?.profile?.text?.otp?.text}
`